import React, { Navigate, Route, Routes } from "react-router-dom";
import PatterningPage from "./PatterningPage";
import StylingPage from "./StylingPage";
import TilingPage from "./TilingPage";

export default function WorkspaceRouter() {
  return (
    <Routes>
      {/* Redirect /workspace to /workspace/tilesets by default */}
      <Route path="/" element={<Navigate to="tiling" replace />} />

      {/* WFC Generation Pages */}
      <Route path="tiling" element={<TilingPage />} />
      <Route path="patterning" element={<PatterningPage />} />
      <Route path="styling" element={<StylingPage />} />
    </Routes>
  );
}
